import { Button, useMediaQuery } from "@mui/material";
import { theme } from "../styles/mui-theme";

export const RegisterButtonAtom = ({ onRegisterClick }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Button
      variant="primary"
      maxWidth={isMobile ? "100%" : "320px"}
      onClick={onRegisterClick}
      size="large"
      sx={
        isMobile
          ? { zIndex: 11, margin: "20px auto", maxWidth: "calc(100% - 40px)" }
          : { marginTop: "10px" }
      }
    >
      {"Register now"}
    </Button>
  );
};
